module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS40ODYiIGhlaWdodD0iMTEuMzUiIHZpZXdCb3g9IjAgMCAyMS40ODYgMTEuMzUiPgogIDxwYXRoIGlkPSLjg5HjgrlfMTI2OSIgZGF0YS1uYW1lPSLjg5HjgrkgMTI2OSIgZD0iTTEyLDEzLjA3OSwyLDQuNDQyLDMuNTUzLDMuMDc5LDEyLDEwLjU4N2w4LjctNy41MDhMMjIsNC40NDJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS4yMzggLTIuMzkpIiBmaWxsPSIjOWJjNzM3IiBzdHJva2U9IiM5YmM3MzciIHN0cm9rZS13aWR0aD0iMSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-display-icon.svg
// module id = yBtO
// module chunks = 3